<template>
  <div class="container" v-if="!isEdit || (isEdit && seasonModel.name != '')">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>emoji_events</md-icon>
        </div>
        <h4 class="title">{{ isEdit ? $t("seasons.edit.title") : $t("seasons.create.title") }}</h4>
      </md-card-header>

      <md-card-content>
        <!-- Name -->
        <md-field :class="{'md-error': $v.seasonModel.name.$error && $v.seasonModel.name.$invalid, 'md-valid': !$v.seasonModel.name.$error && !$v.seasonModel.name.$invalid}">
          <label>{{ isEdit ? $t("seasons.edit.name") : $t("seasons.create.name") }}</label>
          <md-input v-model.trim="$v.seasonModel.name.$model"></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="$v.seasonModel.name.$error && $v.seasonModel.name.$invalid">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!$v.seasonModel.name.$error && !$v.seasonModel.name.$invalid">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </md-card-content>

      <md-card-actions class="actions">
        <md-button @click="save()" class="md-info" :disabled="loading">
          <span>{{ isEdit ? $t("seasons.edit.edit") : $t("seasons.create.create") }}</span>
        </md-button>
        <md-button class="md-simple md-danger" v-if="isEdit" @click="seasonDelete" :disabled="loading">
          {{ $t("seasons.edit.delete") }} <md-icon>delete</md-icon>
        </md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { SlideYDownTransition } from "vue2-transitions";
import { mapState } from 'vuex';

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      loading: false,
      seasonId: "",
      seasonModel: {
        name: ""
      }
    };
  },
  computed: {
    ...mapState({
      listSeasons: state => state.StuffModule.seasons
    }),
    isEdit() {
      return this.$route.params.id != undefined;
    }
  },
  mounted() {
    console.log(this.isEdit)
    if (this.isEdit) {
      this.seasonId = this.$route.params.id;

      if (this.listSeasons.length === 0) {
        this.loading = true;
        this.$store.dispatch("seasonsGet").then(_ => {
          const season = this.$store.getters.getSeasonById(this.seasonId);
          this.seasonModel = { ...season };
          this.loading = false;
        });
      } else {
        const season = this.$store.getters.getSeasonById(this.seasonId);
        this.seasonModel = { ...season };
      }
    }
  },
  methods: {
    async save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.isEdit) {
          this.loading = true;
          const response = await this.$store.dispatch("seasonUpdate", this.seasonModel);
          if (response != undefined) {
            this.$notify({
              message: this.$t(`notifications.season.update`),
              icon: 'add_alert',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success'
            })
          } else {
            this.$store.dispatch("openModalError")
          }
          this.loading = false;
        } else {
          this.loading = true;
          const response = await this.$store.dispatch("seasonCreate", this.seasonModel);
          if (response != undefined) {
            this.$notify({
              message: this.$t(`notifications.season.create`),
              icon: 'add_alert',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success'
            })
          } else {
            this.$store.dispatch("openModalError")
          }
          this.loading = false;
        }
        return;
      }
      return;
    },
    async seasonDelete() {
      if (this.isEdit) {
        this.loading = true;
        const response = await this.$store.dispatch("seasonDelete", {id: this.seasonModel.id});
        if (response != undefined) {
          this.$notify({
            message: this.$t(`notifications.season.remove`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success'
          })
          this.$router.push("/list/season");
        } else {
          this.$store.dispatch("openModalError")
        }
        this.loading = false;
      } else {
        return;
      }
    }
  },
  watch: {
    isEdit(newVal) {
      if (newVal === false) {
        this.seasonModel = { name: "" };
        this.$v.$reset()
      }
    }
  },
  validations: {
    seasonModel: {
      name: {
        required
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .actions {
    display: flex;
    justify-content: space-between;
  }
</style>
